import React, { useRef, useEffect, useState } from 'react';
import { MdClose } from "react-icons/md";
// import './Modal_review.css';
import './Modal.css';

const Modal = ({ isOpen, hasCloseBtn = true, onClose,className, children }) => {
  const [isModalOpen, setModalOpen] = useState(isOpen);
  const modalRef = useRef(null);

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
      
    document.body.style.overflow = 'auto';
    }
    setModalOpen(false);
  };
  
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      // handleCloseModal();
      event.preventDefault();
        event.stopPropagation();
    }
  };

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement) {
      if (isModalOpen) {
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isModalOpen]);

  return (
    <dialog ref={modalRef} onKeyDown={handleKeyDown} className={className}>
      {hasCloseBtn && (
        <span className="modal-close-btn flex-center" onClick={handleCloseModal}>
         <MdClose/>
        </span>
      )}
      <div>
      {children}
      </div>
     
    </dialog>
  );
};

export default Modal;
